import { SettingsData, LocaleOptionsType } from "../components/Settings/Settings.types";

const KEY = "app_settings";

export const languageToLocaleMap: Record<string, LocaleOptionsType> = {
  en: "en-US",
  es: "es-MX",
};

export const mapLanguageToLocale = (language: string): LocaleOptionsType => {
  return languageToLocaleMap[language] ?? "en-US";
};

export const getSystemTheme = (): "light" | "dark" =>
  window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

export const getAppSettings = (): SettingsData => {
  const browserLang = navigator.language;

  try {
    const raw = localStorage.getItem(KEY);
    return raw
      ? JSON.parse(raw)
      : { locale: mapLanguageToLocale(browserLang), theme: "system", unit_system: "Imperial" };
  } catch {
    return { locale: mapLanguageToLocale(browserLang), theme: "system", unit_system: "Imperial" };
  }
};

export const setAppSettings = (settings: SettingsData) => {
  localStorage.setItem(KEY, JSON.stringify(settings));
};
